import React, {useEffect, useState} from 'react';
import {Grid} from "@mui/material";
import GroupSummaries from '../../../GroupSummaries/GroupSummaries/GroupSummaries';
import GroupSummariesLoader from '../../../GroupSummaries/GroupSummaries/GroupSummariesLoader';
import {requestAdminInvoicesSummary} from "../../../../requests/reports/invoices/admin-invoice-requests";
import {getErrorMessageForNonStandardAndStandardResponse} from "../../../../util/NetworkErrorUtil";
import {formatCurrencyValue} from "../../../../util/PaymentUtils";
import {omit} from "underscore";
import type {AdminInvoicesQueryType} from "./AdminInvoicesQueryType";
import {useSnackbar} from "../../../../context/snackbar-context";

interface GroupSummaryField {
  title: string;
  value: string;
}

interface InvoiceGroupSummaryProps {
  query: AdminInvoicesQueryType;
}

const InvoiceGroupSummary = ({query}: InvoiceGroupSummaryProps) => {
  const [loading, setLoading] = useState(false);
  const [groupSummaryFields, setGroupSummaryFields] = useState<GroupSummaryField[]>([]);
  const { snackbarShowMessage } = useSnackbar();

  useEffect(() => {
    setLoading(true);
    // Remove unused fields
    const filteredQuery = omit(query, ['sortBy', 'sortDir', 'page', 'size']);
    requestAdminInvoicesSummary(filteredQuery)
      .then(response => {
        setGroupSummaryFields([
          {title: 'Buyer Charges', value: String(formatCurrencyValue(response.body.buyerCharges, true))},
          {title: 'Payment Processor Fees', value: String(formatCurrencyValue(response.body.paymentProcessorFees, true))},
          {title: 'Supplier Payouts', value: String(formatCurrencyValue(response.body.supplierPayouts, true))},
          {title: 'SecurSpace Fees', value: String(formatCurrencyValue(response.body.securSpaceFees, true))}
        ]);
      })
      .catch(error => {
        snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(error), 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [query, snackbarShowMessage]);

  return (
    <Grid item xs={12}>
      {
        loading ? <GroupSummariesLoader /> :
          <GroupSummaries groupSummaryFields={groupSummaryFields} />
      }
    </Grid>
  );
};

export default InvoiceGroupSummary;
